<script setup lang="ts">
// Tunduk — the crown of the yurt and the emblem on the Kyrgyz flag. Rendered
// as a thin-line watermark; rays are generated so no path data is hand-typed.
</script>

<template>
  <svg viewBox="0 0 200 200" fill="none" stroke="currentColor" aria-hidden="true">
    <circle cx="100" cy="100" r="93" stroke-width="2" />
    <circle cx="100" cy="100" r="62" stroke-width="2" />
    <line
      v-for="i in 40"
      :key="i"
      x1="100" y1="2" x2="100" y2="12"
      stroke-width="2"
      stroke-linecap="round"
      :transform="`rotate(${i * 9} 100 100)`"
    />
    <path d="M42 84 Q100 70 158 84" stroke-width="2.5" stroke-linecap="round" />
    <path d="M40 100 Q100 88 160 100" stroke-width="2.5" stroke-linecap="round" />
    <path d="M42 116 Q100 106 158 116" stroke-width="2.5" stroke-linecap="round" />
    <path d="M84 42 Q70 100 84 158" stroke-width="2.5" stroke-linecap="round" />
    <path d="M100 40 Q88 100 100 160" stroke-width="2.5" stroke-linecap="round" />
    <path d="M116 42 Q106 100 116 158" stroke-width="2.5" stroke-linecap="round" />
  </svg>
</template>
